/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_StartedInputs */

const en_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap To shot changes started... please wait.`)
};

const fr_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alignement sur les changements de plan en cours... veuillez patienter.`)
};

const de_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Änderungen an Snap To Shot wurden gestartet... bitte warten.`)
};

const it_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche allo scatto avviate... attendere prego.`)
};

const ru_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начались изменения в функции Snap To shot... пожалуйста, подождите.`)
};

const es_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se iniciaron los cambios en la toma Snap To... por favor espere.`)
};

const zh_cn2_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照更改已开始……请稍候。`)
};

const ja_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スナップ ショットの変更が開始されました... お待ちください。`)
};

const hi_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्नैप टू शॉट में बदलाव शुरू हो गए हैं... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_snap_to_shot_changes_started = /** @type {(inputs: Snap_To_Shot_Changes_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As alterações do Snap To Shot foram iniciadas... aguarde.`)
};

/**
* | output |
* | --- |
* | "Snap To shot changes started... please wait." |
*
* @param {Snap_To_Shot_Changes_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_started = /** @type {((inputs?: Snap_To_Shot_Changes_StartedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_StartedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_shot_changes_started(inputs)
	if (locale === "de") return de_snap_to_shot_changes_started(inputs)
	if (locale === "it") return it_snap_to_shot_changes_started(inputs)
	if (locale === "ru") return ru_snap_to_shot_changes_started(inputs)
	if (locale === "es") return es_snap_to_shot_changes_started(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_shot_changes_started(inputs)
	if (locale === "ja") return ja_snap_to_shot_changes_started(inputs)
	if (locale === "hi") return hi_snap_to_shot_changes_started(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_shot_changes_started(inputs)
	return en_snap_to_shot_changes_started(inputs)
});